import React, { useEffect, useState } from 'react';
import {BrowserRouter, Switch, Route, useHistory,Link} from 'react-router-dom'
import About from '../../pages/About';
import Contact from '../../pages/Contact';
import Home from '../../pages/Home';
import Portfolio from '../../pages/Portfolio';
import BrandLogo from '../../assets/brandIcon.png';

const MenuItems = () =>{
    const history = useHistory();
    const [navBackground,setNavBackground] = useState('normalColor')
    const [fluidClass,setFluidClass]=useState('container')
    const [activeState,setActiveState]=useState({
        home:'active',
        about:'',
        portfolio:'',
        contact:''
    });

    const activeStateChanger = (e) =>{
        const {name} = e.target;

        setActiveState(()=>{
            return{
                [name]: 'active' ,
            }
        })
    }

    useEffect(()=>{
      document.addEventListener("scroll", () => {
        const backgroundcolor = window.scrollY < 100 ? "normalColor" : "scrollColor";
        const fluidState = window.scrollY < 100 ? "container" : "container-fluid";
        setFluidClass(fluidState)
        setNavBackground(backgroundcolor)
      });
    })

    return(
        <>
        <BrowserRouter>
        <div className={`${fluidClass} p-0 sticky-top ${navBackground}`}>
            <nav className="navbar navbar-expand-lg navbar-dark navbar-transparent">
  <Link className="navbar-brand text-uppercase" to="/" name="home" onClick={activeStateChanger}><span className="curlyBrasis" >
    <img src={BrandLogo} alt="brand_icon" className="img-fluid mr-2" style={{width:'50px'}} />
    {`{ `}</span><span>Subin Adhikari</span><span className="curlyBrasis">{` }`}
    </span></Link>
  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{border:'0px'}}>
    {/* <span className="navbar-toggler-icon"></span> */}
    <i className="fa fa-bars"></i>
  </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
    <ul className="navbar-nav ml-auto">
      <li className={`nav-item ${activeState.about}`}>
        <Link className="nav-link text-uppercase" to="/about" name="about" onClick={activeStateChanger}>About</Link>
      </li>
      <li className={`nav-item ${activeState.portfolio}`}>
        <Link className="nav-link text-uppercase" to="/portfolio" name="portfolio" onClick={activeStateChanger}>Portfolio</Link>
      </li>
      <li className={`nav-item ${activeState.contact}`}>
        <Link className="nav-link text-uppercase" to="/contact" name="contact" onClick={activeStateChanger}>Contact</Link>
      </li>
    </ul>
  </div>
</nav>
</div>

<div className="mobileNavBar">
  <div className="d-flex justify-content-center align-items-center col-12 p-0">
      <div className="col-3 p-0">
      <Link className={`nav-link d-flex flex-column justify-content-center align-items-center ${activeState.home}`} to="/home" name="home" onClick={activeStateChanger}>
        <i className="fa fa-home"></i>
        <span>Home</span>
        </Link>
      </div>
      <div className="col-3 p-0">
      <Link className={`nav-link d-flex flex-column justify-content-center align-items-center ${activeState.about}`} to="/about" name="about" onClick={activeStateChanger}>
        <i className="fa fa-user"></i>
        <span>About</span>
        </Link>
      </div>
      <div className="col-3 p-0">
      <Link className={`nav-link  d-flex flex-column justify-content-center align-items-center ${activeState.portfolio}`} to="/portfolio" name="portfolio" onClick={activeStateChanger}>
        <i className="fa fa-briefcase"></i>
        <span>Portfolio</span>
      </Link>
      </div>
      <div className="col-3 p-0">
      <Link className={`nav-link  d-flex flex-column justify-content-center align-items-center ${activeState.contact}`} to="/contact" name="contact" onClick={activeStateChanger}>
        <i className="fa fa-address-book"></i>
        <span>Contact</span>
      </Link>
      </div>
  </div>
</div>
<Switch>
    <Route exact path="/" component={Home} />
    <Route exact path="/about" component={About} />
    <Route exact path="/portfolio" component={Portfolio} />
    <Route exact path="/contact" component={Contact} />
    <Route component={Home} />
</Switch>
</BrowserRouter>
        </>
    )
}
export default MenuItems